import React, { useState, useEffect } from "react";
import categoriesData from "../../../Data/categories.json"; 
import {
  Box,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Select,
  MenuItem,
  Paper,
  IconButton,
  Menu,
  MenuItem as MuiMenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const Index = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name: "",
    slug: "/",
    description: "",
    type: "Fruit",
  });
  const [errors, setErrors] = useState({
    name: "",
    slug: "",
    description: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  useEffect(() => {
    setCategories(categoriesData); 
  }, []);

  const handleClick = (event, category) => {
    setAnchorEl(event.currentTarget);
    setSelectedCategory(category);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    console.log("Edit category", selectedCategory);
    handleClose();
  };

  const handleDelete = () => {
    setCategories(
      categories.filter((category) => category.id !== selectedCategory.id)
    );
    console.log("Deleted category", selectedCategory);
    handleClose();
  };

  const handleCreateCategory = () => {
    let formErrors = { name: "", slug: "", description: "" };

    if (!newCategory.name) {
      formErrors.name = "Name is required";
    }

    if (!newCategory.slug) {
      formErrors.slug = "Slug is required";
    }

    if (!newCategory.description) {
      formErrors.description = "Description is required";
    }

    if (formErrors.name || formErrors.slug || formErrors.description) {
      setErrors(formErrors);
      return;
    }

    const nextOrder =
      categories.length > 0
        ? Math.max(...categories.map((category) => category.order)) + 1
        : 1;

    const newCategoryData = {
      ...newCategory,
      order: nextOrder,
    };

    setCategories([
      ...categories,
      { ...newCategoryData, id: categories.length + 1 },
    ]);
    setNewCategory({ name: "", slug: "", description: "", type: "Fruit" });
    setErrors({ name: "", slug: "", description: "" });
  };

  return (
    <Box
      sx={{ p: 3, margin: "0 auto", display: "flex", flexDirection: "column" }}
    >
      <Typography variant="h5" gutterBottom>
        Categories
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Add, edit or delete a category
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                value={newCategory.name}
                onChange={(e) =>
                  setNewCategory({ ...newCategory, name: e.target.value })
                }
                sx={{
                  "& .MuiInputBase-root": {
                    height: "60px",
                    backgroundColor: "#f7f8f9",
                  },
                }}
                error={Boolean(errors.name)}
                helperText={errors.name}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Slug"
                variant="outlined"
                fullWidth
                value={newCategory.slug}
                onChange={(e) =>
                  setNewCategory({ ...newCategory, slug: e.target.value })
                }
                sx={{
                  "& .MuiInputBase-root": {
                    height: "60px",
                    backgroundColor: "#f7f8f9",
                  },
                }}
                error={Boolean(errors.slug)}
                helperText={errors.slug}
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                value={newCategory.type}
                onChange={(e) =>
                  setNewCategory({ ...newCategory, type: e.target.value })
                }
                sx={{
                  "& .MuiInputBase-root": {
                    height: "60px",
                    backgroundColor: "#f7f8f9",
                  },
                }}
              >
                <MenuItem value="Fruit">Fruit</MenuItem>
                <MenuItem value="Vegetables">Vegetables</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={newCategory.description}
                onChange={(e) =>
                  setNewCategory({
                    ...newCategory,
                    description: e.target.value,
                  })
                }
                sx={{
                  "& .MuiInputBase-root": {
                    height: "160px",
                    backgroundColor: "#f7f8f9",
                  },
                  "& textarea": { paddingTop: "2px" },
                }}
                error={Boolean(errors.description)}
                helperText={errors.description}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleCreateCategory}
                sx={{
                  backgroundColor: "#3bb77e",
                  "&:hover": { backgroundColor: "#35a76d" },
                  height: "60px",
                }}
              >
                Create category
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <TableContainer component={Paper} sx={{ height: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    <Checkbox />
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>ID</TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    Description
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    Slug
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    Order
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#f7f8f9" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categories.map((category) => (
                  <TableRow key={category.id}>
                    <TableCell>
                      <Checkbox />
                    </TableCell>
                    <TableCell>{category.id}</TableCell>
                    <TableCell>{category.name}</TableCell>
                    <TableCell>{category.description}</TableCell>
                    <TableCell>{category.slug}</TableCell>
                    <TableCell>{category.order}</TableCell>
                    <TableCell>
                      <IconButton
                        sx={{
                          border: "1px solid #3bb77e",
                          padding: "8px",
                          borderRadius: "4px",
                          "&:hover": { borderColor: "#35a76d" },
                        }}
                        onClick={(event) => handleClick(event, category)}
                      >
                        <MoreVertIcon />
                      </IconButton>

                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MuiMenuItem onClick={handleEdit}>Edit</MuiMenuItem>
                        <MuiMenuItem onClick={handleDelete}>Delete</MuiMenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Index;
